if (!customElements.get('product-form')) {
    customElements.define('product-form', class ProductForm extends HTMLElement {
      constructor() {
        super();
  
        this.form = this.querySelector('form');
        this.form.querySelector('[name=id]').disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        if (document.querySelector('cart-drawer') && this.submitButton) {
          this.submitButton.setAttribute('aria-haspopup', 'dialog');
        }
  
        this.hideErrors = this.dataset.hideErrors === 'true';
        this.isTeamStoreForm = Boolean(
          this.form?.querySelector('.team-store-cart-properties')
        );
        this.wasInitiallyDisabled = this.submitButton?.hasAttribute('disabled');
        this._onMetaobjectDataRetrieved = this._onMetaobjectDataRetrieved.bind(
          this
        );

        if (this.isTeamStoreForm) {
          this.syncTeamStoreSubmitState();
          window.addEventListener(
            'metaobjectDataRetrieved',
            this._onMetaobjectDataRetrieved
          );
        }
      }

      _onMetaobjectDataRetrieved() {
        this.syncTeamStoreSubmitState();
      }

      hasValidTeamStoreContext() {
        const teamProductData = window.teamProductData || {};
        return window.teamStoreUtilities?.hasRequiredContext(teamProductData)
      }

      syncTeamStoreSubmitState() {
        if (!this.isTeamStoreForm || !this.submitButton) return;

        if (!this.hasValidTeamStoreContext()) {
          this.submitButton.setAttribute('disabled', 'disabled');
          this.submitButton.setAttribute('aria-disabled', 'true');
          this.submitButton.setAttribute('data-team-store-context-locked', 'true');
          return;
        }

        if (!this.submitButton.hasAttribute('data-team-store-context-locked')) {
          return;
        }

        this.submitButton.removeAttribute('data-team-store-context-locked');

        if (!this.wasInitiallyDisabled) {
          this.submitButton.removeAttribute('disabled');
          this.submitButton.removeAttribute('aria-disabled');
        }
      }
  
      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.isTeamStoreForm && !this.hasValidTeamStoreContext()) {
          this.syncTeamStoreSubmitState();
          this.handleErrorMessage(
            'Unable to add to cart. Missing team store opportunity number or product data.'
          );
          return;
        }

        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;
  
        this.handleErrorMessage();
  
        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        const stickyATCBtn = document.querySelector('.sticky-add-to-cart__cta');
        if (stickyATCBtn) stickyATCBtn.classList.add('loading');
        document.querySelectorAll('.loading-overlay__spinner').forEach(spinner => spinner.classList.remove('hidden'));
  
        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];
  
        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;
  
        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {source: 'product-form', productVariantId: formData.get('id'), errors: response.description, message: response.message});
              this.handleErrorMessage(response.description);
  
              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButton.querySelector('span').classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }
  
            if (!this.error) publish(PUB_SUB_EVENTS.cartUpdate, {source: 'product-form', productVariantId: formData.get('id')});
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener('modalClosed', () => {
                setTimeout(() => { this.cart.renderContents(response) });
              }, { once: true });
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            const stickyATCBtn = document.querySelector('.sticky-add-to-cart__cta');
            if (stickyATCBtn) stickyATCBtn.classList.remove('loading');
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error && !this.submitButton.hasAttribute('data-team-store-context-locked')) {
              this.submitButton.removeAttribute('aria-disabled');
            }
            this.syncTeamStoreSubmitState();
            document.querySelectorAll('.loading-overlay__spinner').forEach(spinner => spinner.classList.add('hidden'));
          });
      }
  
      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;
  
        this.errorMessageWrapper = this.errorMessageWrapper || document.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');
  
        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);
  
        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
          document.querySelector('.product__info-wrapper').scrollIntoView({ block: 'start'});
        }
      }
    });
  }
